import {
  TRACKING_DOMAINS,
  VISITOR_ID_PARAM,
  VISITOR_ID_STORAGE_KEY,
  PREVIOUS_VISITOR_ID_STORAGE_KEY,
} from 'define';

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const url = new URL(window.location.href);

if (url.searchParams.has(VISITOR_ID_PARAM)) {
  const incomingId = url.searchParams.get(VISITOR_ID_PARAM);
  const referrerHostname = document.referrer ? new URL(document.referrer).hostname : '';
  // Only trust ids carried by our own cross-domain links, not copied/shared URLs
  const isCrossDomainReferral =
    TRACKING_DOMAINS.includes(referrerHostname) && referrerHostname !== url.hostname;

  if (isCrossDomainReferral && UUID_REGEX.test(incomingId)) {
    const localId = localStorage.getItem(VISITOR_ID_STORAGE_KEY);

    if (localId && localId !== incomingId) {
      localStorage.setItem(PREVIOUS_VISITOR_ID_STORAGE_KEY, localId);
    }

    localStorage.setItem(VISITOR_ID_STORAGE_KEY, incomingId);
  }
}
